import React from 'react';
import PropTypes from 'prop-types';
import { Header } from 'semantic-ui-react';
import PatientReplace from '../../components/ReplaceForm/PatientReplace';
import CallToAction from '../../components/CallToAction';

const ReplaceForm = (props) => {
  return (
    <div className="sign-up full-width replace">
      <div className="top-bar"></div>
      <div className="wrapper">
        <Header as="h1">
        Lost your card?
          <Header.Subheader>
          If you’ve misplaced your <span className="nowrap-txt">Takeda Oncology</span> Co-Pay Card, we can help you retrieve your information.
          </Header.Subheader>
        </Header>
        <p className="intro-replace">Please provide the following:</p>
        <PatientReplace
          environment={ props.environment }
          onSubmit={ props.onSubmit }
        />
        <CallToAction id={ 9 }/>
      </div>
    </div>
  );
};

ReplaceForm.propTypes = {
  environment: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default ReplaceForm;
